import React from 'react';
import "../../../components/sandbox/index.css"
import {Arguments} from "../common/Arguments";

const baseUrl = Arguments.reactUrl.replace("/#", "") + "/att/documents/science/"
const LogoutRelationship = () => {
    return (
        <>
            <div className="panel panel-default mt-20">
                <p style={{fontWeight: 'bold', marginLeft: 20, fontSize: 20}}>民办社会科学研究机构注销</p>
            </div>
            <div className="panel panel-default mt-20">
                <div className="panel-header">工作流程</div>
                <div className="panel-body">
                    <p>1．由理事会提出民办社科研究机构注销动议。</p>
                    <p>2．民办社科研究机构注销动议须经理事会表决通过。</p>
                    <p>3．向市社科联提交如下注销申请材料：</p>
                    <p> （1）《关于注销天津市××××的请示》<a href={`${baseUrl}关于注销天津市××××的请示.docx`}
                                                        style={{color: "blue"}}>点此下载</a></p>
                    <p> （2）理事会会议纪要（加盖机构公章及参会人员签名）。</p>
                    <p> （3）民办社科研究机构注销实施方案。</p>
                    <p>4．成立专门清算组织，清理债权债务，处理善后事宜。清算期间，不得开展清算以外的活动。</p>
                    <p>5．市社科联批复后，由会计师事务所进行清算审计。</p>
                    <p>6．向市社科联报送清算材料：</p>
                    <p> （1）会计师事务所出具的民办社科研究机构清算审计报告。</p>
                    <p> （2）民办社科研究机构清算报告书（包括团体财产清算及清算小组成员签字，报告中应说明资金的去向，说明资产负债情况、财务纠纷状况，有无法律纠纷、工作人员安置问题等）。</p>
                    <p> （3）其他需要说明的材料。</p>
                    <p>7．经审查后，民办社科研究机构持市社科联批复、清算审计报告、《民办非企业单位法人注销申请表》（由市民政局提供）、理事会会议纪要、民办非企业单位法人证书正副本、印章等到市民政局办理注销备案手续。</p>
                    <p>8．民办社科研究机构终止的剩余财产，在市社科联和市民政局的监督下，按照国家相关规定，用于发展与民办社科研究机构宗旨相关的事业。</p>
                </div>
            </div>
        </>
    );
};

export default LogoutRelationship;
